import React from "react";

const AreaDoClienteIconBranco = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 3000 3000"
    {...props}
  >
    <g id="Camada_1">
      <g>
        <path
          d="M2430.8,1389.7L2430.8,1389.7c-12.7-23.2-30.3-40.3-52.3-50.9c-11.4-5.5-21.2-9.5-30.7-12.5
			c-54.3-17.5-110.3-30.9-164.4-43.9l-1.7-0.4c-4.8-1.2-9.7-2.3-14.5-3.3c-13.3-3-25.9-5.8-38.1-10l-0.7-0.2
			c11.9-41.5,20.6-83.6,24.6-126.8c5.7-61.2,3.1-121.9-8.5-182.1c-28.8-148.4-98.8-274.4-213.8-372.5
			c-164.2-140.1-354.4-189.2-566.1-146.6c-146.8,29.6-269.6,103.5-364.9,218.9c-132.4,160.3-179.2,344.7-141.1,549.1
			c22.2,119,76.1,223.2,157.5,312.9c74.5,82.1,164.4,141.4,268.9,177.9c90.6,31.6,183.9,42.9,279.6,33.3
			c45.9-4.6,90.6-13.7,134-27.4c18.3-3.2,36.3-6.5,53.7-9.9c2.7-0.5,5.2-1.1,7.7-1.7c5.4-1.3,10.1-2.4,14.1-2l4,0.4l3.7-1.5
			c7.3-2.9,15.4-4.4,24.1-6c3.3-0.6,6.6-1.2,10-1.9c99.5-20.8,206.5-44.2,313.9-74.4c64.5-18.2,140.6-40.5,216.4-68.2
			c21.7-7.9,41.4-20.2,60.2-37.5c18.3-16.8,29-37.9,32.8-64.8C2441.7,1420.5,2438.8,1404.4,2430.8,1389.7z M2406.5,1432.8
			c-2.8,19.2-9.9,33.6-22.5,45.1c-15.6,14.3-31.7,24.4-49.2,30.8c-74.7,27.4-150.1,49.4-214,67.4c-106.4,30-212.7,53.2-311.7,73.9
			c-3,0.6-6,1.2-9.2,1.8c-8.7,1.6-17.7,3.3-26.8,6.5c-7.7-0.1-14.5,1.5-20.7,3c-2.2,0.5-4.3,1-6.2,1.4
			c-43.5,8.3-90.2,16.8-137.3,22.2c-18,2.1-27.5,2-45.2,0.7c-1.9-0.1-11.4-1.1-13-1.4l-1.1-0.2l-1.1,0c-9.9-0.3-19.2-5.1-30-10.7
			l-2.9-1.5c-21.7-11.1-40.1-26.7-61.2-46.6c-41.2-39-75.4-85-101.5-136.7c-19.4-38.4-38-76.2-52.8-115.5c-4.8-12.6-8-23.1-10.1-33
			c-2.3-10.8,1.3-19.6,10.7-26c12.7-8.6,26.3-13.6,40.6-15c20.1-1.9,39-7.3,57.2-12.4c3.5-1,7.1-2,10.6-3
			c51.5-14.2,93-44.8,127.1-93.7c2.4-3.5,4.8-6.9,7.2-10.4c12-17.3,24.4-35.2,37.9-51.4c10.2-12.3,18.7-21,29.2-27
			c12.1-6.8,26-10,44.1-10c3.4,0,7,0.1,10.7,0.3c18.2,1.1,35.8,7.8,58.8,22.3c16.1,10.1,30.8,21.9,46.5,34.3
			c2.7,2.2,5.4,4.3,8.1,6.4c40.8,32.3,80.3,57.6,120.5,77.2c8,3.9,16.1,7.3,23.9,10.6c3.5,1.5,7,3,10.5,4.5l1.2,0.5
			c50.8,17.6,107,34,177,51.4c2.5,0.6,4.9,1,6.9,1.3c0.3,0,0.6,0.1,0.9,0.1c13.4,4.5,27,7.6,40.2,10.6c4.6,1,9.4,2.1,14,3.2l1.7,0.4
			c53.6,12.9,108.9,26.2,162,43.3c8,2.6,16.5,6.1,26.5,10.9c15.9,7.6,28.2,19.7,37.6,37v0C2406.5,1414.1,2408,1422.8,2406.5,1432.8z
			"
        />
      </g>
    </g>
    <g id="Camada_4">
      <g>
        <g>
          <path
            d="M1511.4,36.8C716.1,32.1,57.5,659.4,37.5,1464.6C17.5,2272,653,2944.3,1467.1,2962.8
				c798.9,18.2,1461.3-604,1494.5-1401.5C2996.1,735.2,2343.3,45.8,1511.4,36.8z M292.5,1840.5c-22.5-74.4-39.5-146.7-48.1-209.9
				l129,129L292.5,1840.5z M627.1,2411.4c-37.9,9.8-90.9-45.4-145.7-134.4c18.6-17.8,37.1-35.5,55.7-53.3l130.8,130.8
				C648.1,2393.8,643,2407.3,627.1,2411.4z M537.1,2199.9l-138.8-138.8l138.8-138.8l138.8,138.8L537.1,2199.9z M537.1,1898.4
				l-138.8-138.8l138.8-138.8l138.8,138.8L537.1,1898.4z M700.8,2061.1l138.8-138.8l24.9,24.9c-31.5,88-62.5,166.5-79.8,197.9
				L700.8,2061.1z M700.8,1759.6l138.8-138.8l99.6,99.6c-10.1,34.4-22.5,73.7-36,114.3l-63.7,63.7L700.8,1759.6z M1217.8,2451.8
				c-3.8,41.1-9.8,82-19.5,122.2c-12.6,52.2-27.6,103.6-48,153.3c-6.7,16.3-14.8,32-25,46.6c-16.6,24-39.4,38.3-67.7,44
				c-37,7.5-70.5-1.9-100-23.8c-33.1-24.6-55-58.4-71.4-95.9c0,0,0,0,0,0c-9.5-17.2-16.3-35.7-23.2-54
				c-28.4-75.2-50.6-152.1-65.9-231c-2-10.1-3.3-20.4-2.8-30.8c0.2-3.7,0.6-7.3,1.9-10.8c2.7-7.5,6.2-9.8,14.2-9.9
				c6.9-0.1,13.1,2.2,19.2,4.9c10.4,4.6,20.2,10.1,29.7,16.5c19.9,13.4,39.9,26.6,59.8,40c2.2,1.5,4.4,3,6.6,4.4
				c6.9,4.3,7.8,4.1,11.2-3.1c9.3-19.9,18.5-39.9,27.7-59.8c6-13,12-26,20.3-37.8c3.7-5.2,7.7-10.1,12.7-14
				c10.9-8.6,21.5-9.2,33.2-1.8c8,5.1,14.2,12,20,19.4c13.3,17.2,23.1,36.6,34.3,55.1c7.1,11.7,13.9,23.5,20.8,35.3
				c1.7,2.9,3.2,5.8,6.4,7.5c17.5-15.4,33.5-32.5,50.4-48.6c7-6.7,13.9-13.5,21.8-19.1c4.6-3.3,9.3-6.5,14.8-8.1
				c8.1-2.4,12.7-0.4,16.3,7.2c3.3,7,4.4,14.6,5,22.3C1221.9,2405.3,1220,2428.6,1217.8,2451.8z M2209.8,2461.6
				c-5,50.1-13.8,99.6-27.6,148.1c-12.8,45.2-25.7,90.3-45.9,133c-7.7,16.3-17.1,31.6-29.4,45c-15.2,16.7-34.7,25.6-56.3,30.2
				c-36.2,7.7-69.3-1.6-98.4-22.5c-33.5-24.1-55.6-57.8-72.1-95.2c0,0,0,0,0,0c0,0,0,0,0,0c-7-11-11.3-23.3-16.1-35.3
				c-32.1-80.2-56.3-162.8-73.2-247.5c-2.7-13.3-5.2-26.8-2.9-40.6c2.2-12.6,8.1-17.1,21-14.6c11.6,2.3,22.1,7.4,31.9,13.8
				c24.8,16.2,49.4,32.7,74.2,49c10.9,7.2,10.1,9.7,17-5.3c10.8-23.6,21.7-47.2,32.8-70.6c5.9-12.4,12.8-24.1,22.8-33.7
				c12.4-11.8,24.6-12.8,38.6-2.7c11.6,8.3,19.9,19.6,27.2,31.6c15,24.7,29.6,49.8,44.4,74.6c2.1,3.6,3.1,8.4,8.4,9
				c18.3-17.9,36.7-35.9,55-53.8c6.2-6.1,12.8-11.7,20.1-16.3c3.1-2,6.3-3.8,9.7-5c8.8-3.2,13.8-1,17.6,7.7c4.3,10,5,20.7,5.3,31.3
				C2214.5,2415.2,2212.1,2438.4,2209.8,2461.6z M2761.8,1560.8c-0.4,6.9-0.8,13.8-1.2,20.7c-15.9,238.2-93.2,455.3-231.2,651.1
				c-50.3,71.3-108,136.3-172.1,195.6c-1.9,1.8-3.4,4.1-6.2,4.7c-2.9-2.7-3.2-6.6-4.3-10c-37.9-110.6-92.7-210.6-164-300
				c-26.6-33.3-55.5-65.2-86.7-95.6c-96.6-94.2-209-163.7-337.2-206.5c-62.1-20.7-125.9-33.7-191.4-39.4
				c-66.8-5.8-133.3-3.4-199.3,7.3c-106.4,17.2-205.9,53.7-298.6,108.8c-82.8,49.2-155.5,110.1-219.1,181.3
				c50.2-125.1,121.2-335.6,141.6-428.1c0.2-0.8,0.3-1.6,0.5-2.4c6.5-34.8-16.8-68.6-51.9-75.4c-40-7.8-89.2-15.4-177.8-18.9
				c-62.1-2.4-196.2-6.3-259.7-3.6c-14.2,0.6-30.8,1.2-48.4,1.9c-63,2.3-145.3,5.4-216.1,12.4c-4.6-97.3,4.6-189.6,4.6-189.6
				c10.1-101.9,32.2-201.3,66.8-297.7c66.9-187.1,171.6-350.1,315-487.7C790,431,984.6,325.3,1207.3,271.5
				c71.1-17.2,143.2-27.8,216.3-32c234.9-13.6,456.8,34,665,143.1c169.8,89,311.8,211.2,426.1,365.2
				c104.7,141.1,176.6,297.4,216.3,468.6C2757.2,1329.7,2767.8,1444.6,2761.8,1560.8z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default AreaDoClienteIconBranco;
